<template>
  <div :class="{'modal':true, 'show':show}">
    <div class="bg-overlay"></div>
    <div class="modal-content">
      <div class="loader-box" v-if="loading">
        <i class="fas fa-spinner fa-spin fa-fw fa-2x"></i>
        <label>{{ msg }}</label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'asap-modal',
  data () {
    return {
      loading: false,
      msg: '',
      bidId: '',
      statusDelay: ''
    }
  },
  computed: {
    rsvpEdit () { return this.$store.state.rsvpDetails.edit },
    asap () { return this.$store.state.rsvpDetails.asapRequest },
    show: {
      get () { return this.asap.show },
      set (x) { this.$store.commit('rsvpDetails/setAsapModal', x) }
    },
    asapData () { return this.asap.data }
  },
  methods: {
    startAsap () {
      let self = this
      console.log('startAsap', 1)
      if (self.loading) return
      console.log('startAsap', 2)
      self.loading = true
      self.msg = 'Processing booking. . .'
      let param = JSON.parse(JSON.stringify(self.asapData))
      param.consumerId = self.rsvpEdit.details.customerInfo.id
      param.lyft = param.legs[0].lyft
      param.source = 'C'

      console.log('param', param)
      self.$sdk.post('/bid/lyft/create', param, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.loading = false
          self.show = false
          return
        }
        self.bidId = r.bid.bidId
        self.msg = 'Searching for nearby drivers. . .'
        self.getLyftStatus(r)
      }, '2.0')
    },
    getLyftStatus (data) {
      let self = this
      if (self.statusDelay) clearTimeout(self.statusDelay)
      self.$sdk.post('/bid/lyft/status', {
        token: self.$store.state.session.sessionToken,
        bidId: data.bid.bidId
      }, r => {
        if (self.statusDelay) clearTimeout(self.statusDelay)

        if (r.status === 'canceled') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'No Driver found. Please try again later.'
          })
          self.loading = false
          self.show = false
          return
        }

        if ((r.rsvpId || r.status === 'accepted') && r.lyft.driver) {
          self.loading = false
          self.show = false
          self.$store.commit('rsvpDetails/setIsAdd', false)
          window.location = '/#/reservation/' + r.rsvpId
          return
        }
        self.statusDelay = setTimeout(() => {
          self.getLyftStatus(data)
        }, 5000)
      }, '2.0')
    }
  },
  watch: {
    show (val) {
      let self = this
      if (val) {
        // self.error.show = false
        // self.error.message = ''
        console.log('show')
        self.startAsap()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal{
  position: fixed;
  z-index: 22;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  justify-content: center;
  resize: vertical;

  .bg-overlay{
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .modal-content{
    position: relative;
    z-index: 2;
    background: #fff;
    max-width: 600px;
    border-radius: 6px;
    padding: 20px;
    margin: auto;
    box-shadow: 1px 1px 5px 1px rgba(0,0,0, .3);
    display: none;
  }
  &.show{
    display: flex;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .15s ease-out;
      -moz-animation: slide-down .15s ease-out;
    }
  }
}

.loader-box{
  text-align: center;

  label{
    color:#666;
    display: block;
    line-height: 1;
    letter-spacing: .5px;
    margin-top: 20px;
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RsvpDetails/AsapModal.vue